import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_TICKETS = ROUTE_PATH_ADMIN + '/tickets';
